var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup427320187(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 20H5.83333C5.37333 20 5 19.6267 5 19.1667C5 18.7067 5.37333 18.3333 5.83333 18.3333H10.8333C14.055 18.3333 16.6667 15.7217 16.6667 12.5V5C16.6667 4.54 17.04 4.16667 17.5 4.16667C17.96 4.16667 18.3333 4.54 18.3333 5V12.5C18.3333 16.6425 14.9758 20 10.8333 20ZM10.8333 0H10.6917C10.31 0 10 0.31 10 0.691667C10 1.92917 9.1675 3.0825 7.9475 3.29417C6.36917 3.56833 5 2.36083 5 0.833333C5 0.833333 5 0 4.16667 0C1.86583 0 0 1.86583 0 4.16667V12.5C0 14.8008 1.86583 16.6667 4.16667 16.6667H4.30833C4.69083 16.6667 5 16.3567 5 15.975C5 14.7375 5.8325 13.5842 7.0525 13.3725C8.63083 13.0992 10 14.3067 10 15.8333C10 15.8333 10 16.6667 10.8333 16.6667C13.1342 16.6667 15 14.8008 15 12.5V4.16667C15 1.86583 13.1342 0 10.8333 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup427320187);
export default __webpack_public_path__ + "static/media/Group 427320187.4d0ea7989a48f20d19d8fa63bd39d501.svg";
export { ForwardRef as ReactComponent };